export const MISSING_TRANSLATION = '--';

const PLACEHOLDER = /\$\{\s*([^}\s]+)\s*\}/g;

/**
 * Replaces ${name} placeholders with the matching value; a placeholder with no value stays as is.
 * @param {string} text - Translated text possibly holding ${name} placeholders.
 * @param {Object} [data] - Values keyed by placeholder name.
 * @returns {string} The text with every resolvable placeholder replaced.
 * @author armandoricosandoval -ai-
 */
export const interpolate = (text, data) => {
  if (typeof text !== 'string' || data === null || typeof data !== 'object') {
    return text;
  }
  return text.replace(PLACEHOLDER, (placeholder, key) => (data[key] === undefined ? placeholder : String(data[key])));
};
